import {
  MAX_TOKEN_DURATION_MINUTES,
  MIN_TOKEN_DURATION_MINUTES,
  TokenDurationUnit,
} from '../../../types/auth/TokenConfigurationTypes';

export const toMinutes = (value: number, unit: TokenDurationUnit): number =>
  unit === 'hours' ? Math.round(value * 60) : Math.round(value);

export const fromMinutes = (minutes: number, unit: TokenDurationUnit): number =>
  unit === 'hours' ? minutes / 60 : minutes;

export const validateDuration = (
  value: number,
  unit: TokenDurationUnit
): string | null => {
  if (!Number.isFinite(value)) return 'La duración del token es obligatoria.';

  const minutes = toMinutes(value, unit);
  if (minutes < MIN_TOKEN_DURATION_MINUTES) {
    return 'La duración mínima es de 5 minutos.';
  }
  if (minutes > MAX_TOKEN_DURATION_MINUTES) {
    return 'La duración máxima es de 7 días (10080 minutos).';
  }

  return null;
};

export const readableDuration = (minutes: number): string => {
  if (minutes % 60 === 0) {
    const hours = minutes / 60;
    return `${hours} ${hours === 1 ? 'hora' : 'horas'}`;
  }

  return `${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}`;
};
